import { adminInvitationsEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";

export const cancelInvitationHandler = async (id: number | string): Promise<void> => await axiosClient["delete"](adminInvitationsEndpoints.byId(id));
